import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LocaleService } from '@app/system/services/locale.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';

@Component({
	selector: 'app-info-card',
	templateUrl: './info-card.component.html',
	styleUrls: ['./info-card.component.scss']
})
export class InfoCardComponent implements OnInit {

	@Input() type: 'playlist' | 'common' | 'workgroup' = 'common';
	@Input() data: any;
	@Output() emitter = new EventEmitter();

	constructor(
		public locale: LocaleService,
		public gfService: GlobalFunctionService
	) { }

	ngOnInit(): void {
	}

	info(record) {
		if (navigator.onLine) {
			this.emitter.emit(record);
		}
	}
}
